import {
  AutoComplete, Form, Input,
} from 'antd';
import useMailMergeFields from 'automations/hooks/useMailMergeFields';
import { filterMailMergeOptions, getMailMergeValue } from 'crm-atoms/utils';
import { useCallback } from 'react';

import FormItemTitle from './FormItemTitle';

export default function AddSubjectForm() {
  const {
    options: mailMergeOptions,
  } = useMailMergeFields({});

  const form = Form.useFormInstance();
  const subjectText = Form.useWatch('subject', form) ?? '';
  const showOptions = subjectText.includes('@');
  const searchString = subjectText.slice(subjectText.lastIndexOf('@') + 1);
  const filteredOptions = filterMailMergeOptions(mailMergeOptions, searchString);

  const handleSelect = useCallback((newValue: string) => {
    form.setFieldValue('subject', subjectText.slice(0, subjectText.lastIndexOf('@')) + getMailMergeValue(newValue));
  }, [form, subjectText]);

  return (
    <Form.Item
      name="subject"
      label={<FormItemTitle>Subject</FormItemTitle>}
      rules={[{ required: true }, { min: 1, message: 'Subject is required' }]}
    >
      <AutoComplete
        options={showOptions ? filteredOptions : []}
        onSelect={handleSelect}
      >
        <Input placeholder="Add Subject, Use @ to add mail merge field" />
      </AutoComplete>
    </Form.Item>
  );
}
